import React, { BaseSyntheticEvent, FormEvent, Ref, useCallback } from "react";

import { Field } from "@atlaskit/form";
import TextArea from "@atlaskit/textarea";

import { formField } from "./form-field.styles";
import { formTextArea } from "./form-text-area.styles";

import { SpotlightTarget } from ".";

const maxCharacterLength = 999;

export const FormTextArea = ({
    id,
    name,
    label,
    required,
    disabled,
    maxHeight,
    placeholder,
    forwardRef,
    onStepComplete
}: FormTextAreaProps) => {
    const complete = useCallback(
        onStepComplete
            ? (data: BaseSyntheticEvent) => {
                  if (validateData(data.target)) {
                      onStepComplete();
                  }
              }
            : () => console.warn("onStepComplete is not defined."),
        [onStepComplete]
    );

    const keyDownHandler = (
        event: React.KeyboardEvent<HTMLTextAreaElement>
    ) => {
        if (
            event.key === "Enter" &&
            validateData(event.target as CustomEventTarget)
        ) {
            event.preventDefault();
            if (onStepComplete) onStepComplete();
        }
    };

    const validateData = (target: CustomEventTarget) => {
        return target.value.length > 0;
    };

    return (
        <div css={formField}>
            <Field name={name} label={label} isDisabled={disabled}>
                {({ fieldProps }) => (
                    <SpotlightTarget name={name}>
                        <TextArea
                            {...fieldProps}
                            onChange={(inputElement: unknown) =>
                                // resolves issue with type error between ChangeEventHandler<HTMLTextAreaElement> and FormEvent<HTMLInputElement>
                                fieldProps.onChange(
                                    inputElement as FormEvent<HTMLInputElement>
                                )
                            }
                            id={id}
                            css={formTextArea}
                            placeholder={placeholder}
                            isRequired={required}
                            maxHeight={maxHeight}
                            onBlur={complete}
                            onKeyDown={keyDownHandler}
                            ref={forwardRef}
                            maxLength={maxCharacterLength}
                        />
                    </SpotlightTarget>
                )}
            </Field>
        </div>
    );
};

type FormTextAreaProps = {
    id: string;
    name: string;
    label: string;
    required: boolean;
    disabled?: boolean;
    placeholder: string;
    forwardRef?: Ref<HTMLTextAreaElement>;
    maxHeight: string;
    onStepComplete?: () => void;
};

type CustomEventTarget = {
    value: string;
} & EventTarget;
